/** Shared CRM-style surface tokens for Initial Review workspace. */
export const CRM_CARD_SX = {
  borderRadius: 2,
  boxShadow: "0 2px 8px rgba(15, 23, 42, 0.07)",
  border: "1px solid",
  borderColor: "rgba(0, 0, 0, 0.06)",
  bgcolor: "background.paper",
  overflow: "visible",
  width: "100%",
};

export const CRM_SECTION_TITLE_SX = {
  fontWeight: 700,
  fontSize: "1rem",
  lineHeight: 1.5,
};

export const CRM_CARD_BODY_SX = {
  p: { xs: 2, md: 2.5 },
};

export const CRM_CARD_HEADER_SX = {
  px: { xs: 2, md: 2.5 },
  py: 1.5,
  borderBottom: 1,
  borderColor: "divider",
};

/** 24px vertical rhythm between stacked cards */
export const PAGE_STACK_SPACING = 3;

export const CRM_FIELD_GRID = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "repeat(3, 1fr)" },
  gap: 2,
};

export const FULL_WIDTH_STACK_SX = {
  display: "flex",
  flexDirection: "column",
  gap: PAGE_STACK_SPACING,
  width: "100%",
};
